export default class ResourceNotFoundError extends Error {
	public constructor(message?: string) {
		super(message);
		this.name = 'ResourceNotFoundError';
	}
}

export function throwIfNotResourceNotFoundError(error: Error): void {
	// ignore offline errors, throw everything else
	if (error instanceof ResourceNotFoundError) return;

	throw error;
}
